import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import Box from "@mui/material/Box";

import WebsiteFooter from "components/Footer/WebsiteFooter";
import IbanHeader from "components/Header/IbanHeader";

import VideoSection, {
  VideoSectionContent,
} from "../../IbanOplata/VideoSection";
import Solution from "../../IbanOplata/Solution";
import HowItWorks from "../../IbanOplata/HowItWorks";
import SocialProof from "../../IbanOplata/SocialProof";
import APIIntegration from "../../IbanOplata/APIIntegration";
import FAQ from "../../IbanOplata/FAQ";
import ContactUs from "../../IbanOplata/ContactUs";
import BlogArticles from "../../IbanOplata/BlogArticles";
import MediaPublications from "../../IbanOplata/MediaPublications";

import { useAppDispatch } from "store/hooks";
import { getLatestBlogArticles } from "store/features/homeSlice";

interface SipPageMeta {
  title: string;
  description: string;
  canonicalPath: string;
}

interface SipPageProps {
  meta: SipPageMeta;
  section: VideoSectionContent;
}

const SipPage: React.FC<SipPageProps> = ({ meta, section }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getLatestBlogArticles());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <link
          rel="canonical"
          href={`${window.location.origin}${meta.canonicalPath}`}
        />
      </Helmet>

      <IbanHeader />

      <Box sx={{ backgroundColor: "#fff" }}>
        <VideoSection section={section} />
        <Solution />
        <MediaPublications />
        <APIIntegration />
        <HowItWorks />
        <BlogArticles />
        <SocialProof />
        <FAQ />
        <ContactUs />
      </Box>

      <WebsiteFooter />
    </>
  );
};

export default SipPage;
